export default __webpack_public_path__ + "static/media/Group 41.fc0f1deb.svg";